// src/apiConfig.js
const LOCAL_URL = import.meta.env.VITE_BACKEND_LOCAL_URL;
const PROD_URL = import.meta.env.VITE_BACKEND_PROD_URL;

const environments = {
  local: LOCAL_URL,
  prod: PROD_URL,
};

const activeEnvironment = environments.prod;

const apiEndpoints = {
  // auth
  signUp: `${activeEnvironment}/auth/user-signup`,
  login: `${activeEnvironment}/login/user-login`,
  verifyOtp: `${activeEnvironment}/auth/verify-email-otp`,
  resendOtp: `${activeEnvironment}/auth/resend-email-otp`,

  // website data not in use

  //  api for getpropmt and suggestion prompt

  suggestionPrompt: `${activeEnvironment}/v1/suggest`,

  // user profile details
  getuserProfile: `${activeEnvironment}/profile/get-user-details`,
  updateUserDetails: `${activeEnvironment}/profile/update-user-details`,

  // Email templates and email provider connection
  customeEmailTemplate: `${activeEnvironment}/emails/add-custom-email-template`,
  checkEmailSpamScore: `${activeEnvironment}/check_spam`,
  createEmailTEmplate: `${activeEnvironment}/emails/templates/ai-generate`,
  connectEmailInitiate: `${activeEnvironment}/api/v1/emails/connect/initiate?provider={provider}&from_email={email}&user_id={userId}`,
  getAllEmailTemplate: `${activeEnvironment}/emails/get-custom-email-templates`,
  fetchCustomEmailTemplateById: `${activeEnvironment}/emails/get-custom-email-template-by-id/{id}`,
  fetchSendingSettings: `${activeEnvironment}/emails/email-daily-usage`,
  checkDomain: `${activeEnvironment}/check_domain`,
  updateCustomEmailTemplate: `${activeEnvironment}/emails/update-custom-email-template/{id}`,
  deleteCustomEmailTemplate: `${activeEnvironment}/emails/delete-custom-email-template`,
  conncetZohoProvide: `${activeEnvironment}/api/v1/emails/connect/initiate?provider={provider}&user_id={userId}&from_email={email}`,
  checkSMPTproviderEmail: `${activeEnvironment}/api/v1/emails/connect/smtp/guess`,
  saveSMTPConfig: `${activeEnvironment}/api/v1/emails/connect/smtp/save`,
  verifySMTPConfig: `${activeEnvironment}/api/v1/emails/connect/smtp/verify`,

  // try email

  sendTrialEmail: `${activeEnvironment}/emails-test/test_users_email`,

  // campagin API
  fetchUserCampaigns: `${activeEnvironment}/campaigns/get-user-campaign`,
  createCampaign: `${activeEnvironment}/campaigns/create-campaigns`,
  bulkSendCampaign: `${activeEnvironment}/emails-campaigns/bulk-send`,
  getCampaignById: `${activeEnvironment}/campaigns/get-campaign-by-id`,
  getCampaignStatistics: `${activeEnvironment}/emails-campaigns/get_campaign_statistics/{id}`,
  fetchLaunchedDetailPerDay: `${activeEnvironment}/campaigns/analytics/launched-detail-per-day`,
  getFollowUpEmailById: `${activeEnvironment}/followup-emails/get_followup_email_bycampaign_id/{id}`,

  // campagin lead batch

  leadBatchAPi: `${activeEnvironment}/lead-batches/create`,
  resumeCampaign: `${activeEnvironment}/campaigns/apply-credit-to-campaign`,
  campaignStatus: `${activeEnvironment}/campaigns/campaign-credit-status`,
  leadBatchItemsBySession: (sessionId) =>
    `${activeEnvironment}/lead-batches/items/by-session/${sessionId}`,

  // search poeple and company API Appolo

  startSession: `${activeEnvironment}/v1/sessions/start`,
  parseIntent: `${activeEnvironment}/v1/parse_intent`,
  searchCompanies: `${activeEnvironment}/v1/search/companies`,
  searchPeople: `${activeEnvironment}/v1/people-search`,
  // search poeeple by org id
  getorgidpeoples: (orgId) => `${activeEnvironment}/v1/search/people/${orgId}`,

  // new search API
  searchApi: `${activeEnvironment}/v1/search`,
  getPromptSuggestions: `${activeEnvironment}/prompt-suggestion/suggestions`,

  // Database search people and companies api

  getDatabaseCompanies: `${activeEnvironment}/v2/companies/search`,
  getDatabasePeopleSearch: `${activeEnvironment}/v2/people/search`,

  //email matrix
  getCampaignMetrics: (campaignId) =>
    `${activeEnvironment}/campaigns/${campaignId}/metrics`,
  getCampaignRecipients: (campaignId) =>
    `${activeEnvironment}/campaigns/${campaignId}/recipients`,

  // payments
  getallPricePlane: `${activeEnvironment}/get-packages`,
  createOrder: `${activeEnvironment}/payments/razorpay/create-order`,
  confirmPayment: `${activeEnvironment}/payments/razorpay/confirm`,
  razorpayCheckout: "https://checkout.razorpay.com/v1/checkout.js",
  fetchPaymentHistory: `${activeEnvironment}/payments/payment-history`,

  // contact us
  contactUs: `${activeEnvironment}/public/contact-us`,

  // fetch-ip-data
  fetchIpInfo: `${activeEnvironment}/fetch-ip-data`,

  // waitinglist

  // forgetpassword api

  forgetPassword: `${activeEnvironment}/auth/reset-password`,
  resetPassword: `${activeEnvironment}/auth/verify-forgot-password-otp`,

  // coupon code
  validateCoupon: `${activeEnvironment}/payments/razorpay/apply-coupon`,
};

export { activeEnvironment, apiEndpoints };
